import { SET_MAIN_DOCUMENT } from '../actions/main';
import { Page } from '../types/document';
// TODO
export default (
  state: MainState = {},
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action: Record<string, any>
): MainState => {
  if (action.type === SET_MAIN_DOCUMENT) {
    return action.payload;
  }
  return state;
};

export type MainState = {
  document?: Page;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error?: any;
  loading?: boolean;
};
